// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date___dv_d","head":"ProcedureTableInfo_head__2tQSQ"};